// extracted by mini-css-extract-plugin
export var card = "_vv-0";